export default __webpack_public_path__ + "static/4-3783b5a18540f0057e79d17ac8930624.svg";